// frontend/src/reducers/postReducers.js
import {
  POST_LIST_REQUEST,
  POST_LIST_SUCCESS,
  POST_LIST_FAIL,
  POST_CREATE_REQUEST,
  POST_CREATE_SUCCESS,
  POST_CREATE_FAIL,
  POST_UPDATE_REQUEST,
  POST_UPDATE_SUCCESS,
  POST_UPDATE_FAIL,
  POST_DELETE_REQUEST,
  POST_DELETE_SUCCESS,
  POST_DELETE_FAIL,
  POST_DETAILS_REQUEST,
  POST_DETAILS_SUCCESS,
  POST_DETAILS_FAIL,
  POST_CREATE_RESET,
  POST_DELETE_RESET,
  POST_UPDATE_RESET,
} from "../constants/postConstants";

// 1) Post List Reducer
//    Holds the list of posts. Typically shape: { loading, posts, error }
export const postListReducer = (state = { posts: [] }, action) => {
  switch (action.type) {
    case POST_LIST_REQUEST:
      return { ...state, loading: true, posts: [] };
    case POST_LIST_SUCCESS:
      return { loading: false, posts: action.payload };
    case POST_LIST_FAIL:
      return { loading: false, error: action.payload, posts: [] };
    default:
      return state;
  }
};

// 2) Post Create Reducer
//    Handles creation of a new post. Typically shape: { loading, success, error, post }
export const postCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case POST_CREATE_REQUEST:
      return { loading: true };
    case POST_CREATE_SUCCESS:
      return { loading: false, postCreateSuccess: true, post: action.payload };
    case POST_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case POST_CREATE_RESET:
      // Return empty object to clear out postCreateSuccess, post, etc.
      return {};
    default:
      return state;
  }
};

// 3) Post Update Reducer
//    Handles updates to an existing post. Typically shape: { loading, success, error, updatedPost }
export const postUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case POST_UPDATE_REQUEST:
      return { loading: true };
    case POST_UPDATE_SUCCESS:
      return {
        loading: false,
        postUpdateSuccess: true,
        updatedPost: action.payload,
      };
    case POST_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case POST_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// 4) Post Delete Reducer
//    Handles deletion of a post. Typically shape: { loading, success, error }
export const postDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case POST_DELETE_REQUEST:
      return { loading: true };
    case POST_DELETE_SUCCESS:
      return {
        loading: false,
        postDeleteSuccess: true,
        deletedPostId: action.payload,
      };
    case POST_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case POST_DELETE_RESET:
      // Clears out postDeleteSuccess, deletedPostId, error
      return {};
    default:
      return state;
  }
};

export const postDetailsReducer = (state = { post: null }, action) => {
  switch (action.type) {
    case POST_DETAILS_REQUEST:
      return { loading: true, post: null };
    case POST_DETAILS_SUCCESS:
      return { loading: false, post: action.payload };
    case POST_DETAILS_FAIL:
      return { loading: false, error: action.payload, post: null };
    default:
      return state;
  }
};
